<template>
    <section class="component register contact-details bg-white shadow-card rounded-lg p-8 mb-6">
        <header class="pt-2 pb-4 text-center">
            <h2 class="font-bold text-2xl md:text-3xl leading-none">Contactgegevens</h2>
        </header>

        <div class="py-4 md:py-10">
            <h2 v-if="fields.student_number.show" class="text-xl md:text-2xl font-bold leading-8 mb-3">Leerling</h2>

            <div class="input-group sm:flex sm:flex-no-wrap">
                <validation-provider v-slot="{ errors }" mode="eager" slim>
                    <div class="input-wrapper mb-3 w-full sm:w-6/12 sm:mr-3" :class="{ 'error': errors[0] }">
                        <label for="first-name" class="block font-medium leading-6 text-black">Voornaam</label>
                        <div class="mt-1 relative rounded-md">
                            <input v-model="firstName" id="first-name" class="form-input border-none block w-full" required />
                        </div>

                        <p v-if="errors[0]" class="message mt-1 text-danger">{{ errors[0] }}</p>
                    </div>
                </validation-provider>

                <validation-provider v-slot="{ errors }" mode="eager" slim>
                    <div class="input-wrapper mb-3 w-full sm:w-6/12" :class="{ 'error': errors[0] }">
                        <label for="last-name" class="block font-medium leading-6 text-black">Achternaam</label>
                        <div class="mt-1 relative rounded-md">
                            <input v-model="lastName" id="last-name" class="form-input border-none block w-full" required />
                        </div>

                        <p v-if="errors[0]" class="message mt-1 text-danger">{{ errors[0] }}</p>
                    </div>
                </validation-provider>
            </div>


            <template v-if="fields.student_number.show">
                <validation-provider v-slot="{ errors }" mode="eager" slim>
                    <div class="input-wrapper mb-3" :class="{ 'error': errors[0] }">
                        <label for="student-number" class="block font-medium leading-6 text-black">Leerlingnummer</label>
                        <div class="mt-1 relative rounded-md">
                            <input v-model.lazy="studentNumber" id="student-number" class="form-input border-none block w-full" required />
                        </div>

                        <p v-if="errors[0]" class="message mt-1 text-danger">{{ errors[0] }}</p>
                    </div>
                </validation-provider>
            </template>

            <validation-provider v-slot="{ errors }" mode="eager" rules="email" slim>
                <div class="input-wrapper mb-3" :class="{ 'error': errors[0] }">
                    <label for="email" class="block font-medium leading-6 text-black">E-mailadres</label>
                    <div class="mt-1 relative rounded-md">
                        <input type="email" v-model.lazy="email" id="email" class="form-input border-none block w-full" required />
                    </div>

                    <p v-if="errors[0]" class="message mt-1 text-danger">{{ errors[0] }}</p>
                </div>
            </validation-provider>

            <validation-provider v-slot="{ errors }" mode="eager" slim :rules="{ regex: /(^\+[0-9]{2}|^\+[0-9]{2}\(0\)|^\(\+[0-9]{2}\)\(0\)|^00[0-9]{2}|^0)([0-9]{9}$|[0-9\-\s]{10}$)/ }">
                <div class="input-wrapper mb-3" :class="{ 'error': errors[0] }">
                    <label for="phone" class="block font-medium leading-6 text-black">Telefoonnummer</label>
                    <div class="mt-1 relative rounded-md">
                        <input type="tel" v-model.lazy="phone" id="phone" class="form-input border-none block w-full" required />
                    </div>

                    <p v-if="errors[0]" class="message mt-1 text-danger">{{ errors[0] }}</p>
                </div>
            </validation-provider>

            <template v-if="fields.insurance_number.show">
                <validation-provider v-slot="{ errors }" mode="eager" slim>
                    <div class="input-wrapper mb-3" :class="{ 'error': errors[0] }">
                        <label for="insureance-number" class="block font-medium leading-6 text-black">Polisnummer</label>
                        <div class="mt-1 relative rounded-md">
                            <input v-model.lazy="insureanceNumber" id="insureance-number" class="form-input border-none block w-full" required />
                        </div>

                        <p v-if="errors[0]" class="message mt-1 text-danger">{{ errors[0] }}</p>
                    </div>
                </validation-provider>
            </template>
        </div>

        <div v-if="fields.parental_fields.show" class="py-4 md:py-10">
            <h2 class="text-xl md:text-2xl font-bold leading-8 mb-3">Ouder/Verzorgende</h2>

            <div class="input-group sm:flex sm:flex-no-wrap">

                <validation-provider v-slot="{ errors }" mode="eager" slim>
                    <div class="input-wrapper mb-3 w-full sm:w-6/12 sm:mr-3" :class="{ 'error': errors[0] }">
                        <label for="parent-first-name" class="block font-medium leading-6 text-black">Voornaam</label>
                        <div class="mt-1 relative rounded-md">
                            <input v-model.lazy="parentFirstName" id="parent-first-name" class="form-input border-none block w-full" :required="fields.parental_fields ? fields.parental_fields.require : false" />
                        </div>

                        <p v-if="errors[0]" class="message mt-1 text-danger">{{ errors[0] }}</p>
                    </div>
                </validation-provider>

                <validation-provider v-slot="{ errors }" mode="eager" slim>
                    <div class="input-wrapper mb-3 w-full sm:w-6/12" :class="{ 'error': errors[0] }">
                        <label for="parent-last-name" class="block font-medium leading-6 text-black">Achternaam</label>
                        <div class="mt-1 relative rounded-md">
                            <input v-model.lazy="parentLastName" id="parent-last-name" class="form-input border-none block w-full" :required="fields.parental_fields ? fields.parental_fields.require : false" />
                        </div>

                        <p v-if="errors[0]" class="message mt-1 text-danger">{{ errors[0] }}</p>
                    </div>
                </validation-provider>

            </div>

            <validation-provider v-slot="{ errors }" mode="eager" rules="email" slim>
                <div class="input-wrapper mb-3" :class="{ 'error': errors[0] }">
                    <label for="parent-email" class="block font-medium leading-6 text-black">E-mailadres</label>
                    <div class="mt-1 relative rounded-md">
                        <input type="email" v-model.lazy="parentEmail" id="parent-email" class="form-input border-none block w-full" :required="fields.parental_fields ? fields.parental_fields.require : false" />
                    </div>

                    <p v-if="errors[0]" class="message mt-1 text-danger">{{ errors[0] }}</p>
                </div>
            </validation-provider>

            <validation-provider v-slot="{ errors }" mode="eager" slim :rules="{ regex: /(^\+[0-9]{2}|^\+[0-9]{2}\(0\)|^\(\+[0-9]{2}\)\(0\)|^00[0-9]{2}|^0)([0-9]{9}$|[0-9\-\s]{10}$)/ }">
                <div class="input-wrapper" :class="{ 'error': errors[0] }">
                    <label for="parent-phone" class="block font-medium leading-6 text-black">Telefoonnummer</label>
                    <div class="mt-1 relative rounded-md">
                        <input type="tel" v-model.lazy="parentPhone" id="parent-phone" class="form-input border-none block w-full" :required="fields.parental_fields ? fields.parental_fields.require : false" />
                    </div>

                    <p v-if="errors[0]" class="message mt-1 text-danger">{{ errors[0] }}</p>
                </div>
            </validation-provider>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        fields: Object
    },

    computed: {
        registrationFormData() {
            return this.$store.state.registrationForm;
        },

        firstName: {
            get() { return this.registrationFormData.first_name },
            set(value) { this.$store.commit('SET_REGISTRATION_FIELD', { property: 'first_name', value }) }
        },

        lastName: {
            get() { return this.registrationFormData.last_name },
            set(value) { this.$store.commit('SET_REGISTRATION_FIELD', { property: 'last_name', value }) }
        },

        email: {
            get() { return this.registrationFormData.email },
            set(value) { this.$store.commit('SET_REGISTRATION_FIELD', { property: 'email', value }) }
        },

        phone: {
            get() { return this.registrationFormData.phone },
            set(value) { this.$store.commit('SET_REGISTRATION_FIELD', { property: 'phone', value }) }
        },

        studentNumber: {
            get() { return this.registrationFormData.student_number },
            set(value) { this.$store.commit('SET_REGISTRATION_FIELD', { property: 'student_number', value }) }
        },

        insureanceNumber: {
            get() { return this.registrationFormData.insurance_number },
            set(value) { this.$store.commit('SET_REGISTRATION_FIELD', { property: 'insurance_number', value }) }
        },

        parentFirstName: {
            get() { return this.registrationFormData.parent_first_name },
            set(value) { this.$store.commit('SET_REGISTRATION_FIELD', { property: 'parent_first_name', value }) }
        },

        parentLastName: {
            get() { return this.registrationFormData.parent_last_name },
            set(value) { this.$store.commit('SET_REGISTRATION_FIELD', { property: 'parent_last_name', value }) }
        },

        parentEmail: {
            get() { return this.registrationFormData.parent_email },
            set(value) { this.$store.commit('SET_REGISTRATION_FIELD', { property: 'parent_email', value }) }
        },

        parentPhone: {
            get() { return this.registrationFormData.parent_phone },
            set(value) { this.$store.commit('SET_REGISTRATION_FIELD', { property: 'parent_phone', value }) }
        },
    }
}
</script>

<style lang="scss" scoped>
.component.register.contact-details {

    header {
        border-bottom: 1px solid #DDDDDD;
    }
}
</style>
